import { MktuClassStore } from '.'

export class MktuClassPrototype {
  constructor(private prototype: MktuClassStore) {}

  clone() {
    return new MktuClassStore(this.prototype.mktuClass, this.prototype.words)
  }
}
